<div class="hover-icon-parent">
  <img [id]="iconId" class="static-icon" [src]="staticIconSVG" [height]="iconHeight" alt="Static Icon"/>
  <span class="hover-icon" aria-hidden="true"
        [style.--icon-url]="'url(' + hoverIconSVG + ')'"
        [style.width.px]="iconHeight" [style.height.px]="iconHeight"></span>
</div>
